import type { SVGProps } from "react";
import * as React from "react";
const SvgHubspot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#FF7A59"
      fillRule="evenodd"
      d="M16.31 16.692c-1.42 0-2.57-1.139-2.57-2.543 0-1.404 1.15-2.543 2.57-2.543 1.419 0 2.57 1.139 2.57 2.543 0 1.404-1.151 2.543-2.57 2.543Zm.769-7.439V6.991a1.74 1.74 0 0 0 1.014-1.57V5.37c0-.957-.79-1.74-1.757-1.74h-.053c-.967 0-1.757.783-1.757 1.74v.052c0 .693.418 1.29 1.014 1.57v2.261a5.01 5.01 0 0 0-2.37 1.033L6.896 5.454c.041-.157.07-.32.07-.49A1.973 1.973 0 0 0 4.985 3 1.973 1.973 0 0 0 3 4.96 1.972 1.972 0 0 0 5.957 6.66l6.173 4.753a4.898 4.898 0 0 0 .077 5.579l-1.878 1.858a1.62 1.62 0 0 0-.465-.075c-.9 0-1.63.721-1.63 1.612 0 .89.73 1.612 1.63 1.612.9 0 1.63-.722 1.63-1.612 0-.161-.032-.314-.076-.46l1.857-1.838a5.02 5.02 0 0 0 3.035 1.019c2.768 0 5.011-2.221 5.011-4.96 0-2.48-1.84-4.528-4.242-4.896Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHubspot;
